import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "e-library-front";

export type listBanner = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
};
export type listData = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
  library_category_name: string;
  library_head_status?: string;
  ready_to_borrow?: boolean;
  search?: string;
  id_library_type?: string;
};
export type like_bookmark = {
  id_library_head: number;
  type: string;
};
export type list_like_bookmark = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
  type?: string;
};
export type add_to_cart = {
  id_library_head: number;
  qty: number;
};
export type cart_payment = {
  id_file: number | null;
  library_payment_head_date: string;
  amount_pay: number;
  items: {
    id_library_head: number;
    qty: number | null;
  }[];
};
export type payment_lock_item = {
  id_library_head: number;
  qty: number;
}
export type cancel_order_cart = {
  id_library_history: number, id_library_detail: number
}
export type payment_buy_item = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
  library_category_name: string;
}
export type list_download_e_library = {
  library_category_name: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
}


export type advance_search = {
  search: {
    search_word: string;
    type: string[];
  }[]
  id_library_types: number[];
  id_library_author_publishers: number[];
  language: string | null;
  start_date: string | null;
  end_date: string | null;
}


export class ELibraryFrontApi extends BaseAPI {
  static listBanner(params: listBanner): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/banner`, { params });
  }

  static list(params: listData): Promise<AxiosResponse> {
    return this.api.get(`${path}/list`, { params: params });
  }
  static findOne(id_library_head: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-data/${id_library_head}`);
  }
  static borrowBook(id_library_head: number): Promise<AxiosResponse> {
    return this.api.post(`${path}/library-head/${id_library_head}/borrow`);
  }
  static bookedBook(id_library_head: number): Promise<AxiosResponse> {
    return this.api.post(`${path}/library-head/${id_library_head}/booked`);
  }
  static borrowOrBookedList(type: string, library_category_name: string, in_borrow?: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/borrow-or-booked`, { params: { type, library_category_name, in_borrow } });
  }
  static listBorrowReturnHistory( library_category_name: string): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/borrow-return-history`, { params: {library_category_name } });
  }
  static cancelBorrow(id_library_head: number): Promise<AxiosResponse> {
    return this.api.delete(
      `${path}/library-head/${id_library_head}/cancel-borrow`
    );
  }
  static cancelBooked(id_library_history: number): Promise<AxiosResponse> {
    return this.api.delete(
      `${path}/library-history/${id_library_history}/cancel-booked`
    );
  }
  static getWaitingLineBooked(id_library_head: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-waiting-line-booked/${id_library_head}`);
  }
  static likeBookmark(body: like_bookmark): Promise<AxiosResponse> {
    return this.api.post(`${path}/like-bookmark`, body);
  }
  static listLikeBookmark(params: list_like_bookmark): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/like-bookmark`, { params });
  }
  static addToCart(body: add_to_cart[]): Promise<AxiosResponse> {
    return this.api.post(`${path}/cart`, body);
  }
  static listCart(): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/cart`);
  }
  static cartCount(): Promise<AxiosResponse> {
    return this.api.get(`${path}/cart-count`);
  }
  static cartDelete(body: {
    id_library_head: number;
    qty: number;
  }): Promise<AxiosResponse> {
    return this.api.post(`${path}/cart/delete`, body);
  }
  static cartPayment(body: cart_payment): Promise<AxiosResponse> {
    return this.api.post(`${path}/cart/payment`, body);
  }
  static paymentLockItem(body: payment_lock_item[]): Promise<AxiosResponse> {
    return this.api.post(`${path}/payment/lock-item`, body)
  }
  static uploadFilePayment(file: FormData): Promise<AxiosResponse> {
    return this.api.post(`${path}/upload-file-payment`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  static findOnePayment(id_library_payment_head: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-data/payment/${id_library_payment_head}`)
  }
  static historyCart(): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/history-payment`);
  }
  static cancelOrder(body: cancel_order_cart[]): Promise<AxiosResponse> {
    return this.api.post(`${path}/payment/cancel-order`, body)
  }
  static historyBuyItem(params: payment_buy_item): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/history-buy-item`, { params })
  }
  static returnBorrow(id_library_head: number): Promise<AxiosResponse> {
    return this.api.patch(`${path}/library-head/${id_library_head}/borrow-item-return`)
  }
  static downloadFile(id_library_file: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/library-file/${id_library_file}/download`, {
      responseType: "arraybuffer"
    })
  }
  static listDownload(params: list_download_e_library): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/download`, { params })
  }
  static historyPayment(): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/history-payment`)
  }
  static advanceSearch(body: advance_search): Promise<AxiosResponse> {
    return this.api.post(`${path}/advance-search`, body)
  }
}
